import React from "react";
import { Modal, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { FiSend } from "react-icons/fi";

interface InvitationSentModalProps {
	isOpen: boolean;
	recipientEmails: string[];
	onClose: () => void;
}

export const InvitationSentModal = ({
	isOpen,
	onClose,
	recipientEmails,
}: InvitationSentModalProps) => {
	const hasMultiple = recipientEmails.length > 1;
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			isCentered
			size="2xl"
		>
			<ModalOverlay
				bg="blackAlpha.700"
				backdropFilter="blur(4px)"
			/>
			<ModalContent
				bg="transparent"
				boxShadow="none"
				maxW="740px"
				mx="auto"
			>
				<div
					className="rounded-xl bg-bg-brand-solid px-10 py-8 text-white shadow-2xl"
					data-testid="invitation-sent-modal"
				>
					<div className="flex items-start justify-between gap-6">
						<h2 className="font-heading text-5xl uppercase leading-none tracking-wide">
							Invitation{hasMultiple && "s"} Sent!!
						</h2>
						<FiSend size={70} />
					</div>
					<div className="mt-6 space-y-4 text-base leading-relaxed">
						<div>
							<p>
								Great news. Your invite is now live and ready for supplier
								responses.
							</p>
							<p className="font-bold">Invitation{hasMultiple ? "s have" : " has"} been sent to:</p>
							{/* Tailwind's preflight resets list-style to none on ul/ol, so
							    the markers have to be re-enabled explicitly. */}
							<ul
								className="mt-1 list-disc ps-6"
								data-testid="invitation-sent-recipients"
							>
								{recipientEmails.map((email) => (
									<li key={email}>{email}</li>
								))}
							</ul>
						</div>
						<p>
							Each supplier will receive an email notification with a direct link
							that will take them straight to the invite once they log in.
						</p>
						<p>
							You can monitor submissions and track activity as suppliers begin
							to respond from your dashboard. We&rsquo;ll notify you with an
							email as soon as submissions come in.
						</p>
					</div>
					<div className="mt-8 flex justify-end">
						<button
							type="button"
							onClick={onClose}
							data-testid="invitation-sent-close"
							className="rounded-md bg-white px-8 py-3 text-base font-medium text-bg-brand-solid hover:bg-gray-100"
						>
							Close
						</button>
					</div>
				</div>
			</ModalContent>
		</Modal>
	);
};
